function CustomIcon({ icon, color, className }) {
  const iconStyles = {
    maskImage: `url(${icon})`,
    WebkitMaskImage: `url(${icon})`,
    color: color,
  };

  return <div className={className} style={iconStyles}></div>;
}

export default CustomIcon;
